export const defaultScopeId = "v3.login";

export const LOGIN_REQUESTED = "LOGIN/LOGIN_REQUESTED";
export const LOGIN_SUCCEEDED = "LOGIN/LOGIN_SUCCEEDED";
export const LOGIN_FAILED = "LOGIN/LOGIN_FAILED";
export const LOGOUT_REQUESTED = "LOGIN/LOGOUT_REQUESTED";
export const LOGOUT_SUCCEEDED = "LOGIN/LOGOUT_SUCCEEDED";
export const LOGOUT_FAILED = "LOGIN/LOGOUT_FAILED";

// eslint-disable-next-line max-statements
export default (state = {
    errors: [],
    loading: false,
    loggedIn: false,
}, { type, data }) => {
    switch (type) {
    case LOGIN_REQUESTED: {
        state.loading = true;
        return state;
    }
    case LOGIN_SUCCEEDED: {
        state.loggedIn = true;
        state.loading = false;
        return state;
    }
    case LOGIN_FAILED: {
        state.loggedIn = false;
        state.loading = false;
        state.errors.push(data);
        return state;
    }
    case LOGOUT_REQUESTED: {
        state.loading = true;
        return state;
    }
    case LOGOUT_SUCCEEDED: {
        state.loggedIn = false;
        state.loading = false;
        return state;
    }
    case LOGOUT_FAILED: {
        state.loading = false;
        state.errors.push(data);
        return state;
    }
    default: return state;
    }
};


export const loginRequested = ({
    redirectUri = `${window.location}`, prompt, maxAge, loginHint, scope = "openid mdv3api", idpHint, action = "login", locale = undefined
}, resolve, reject ) => ({ type: LOGIN_REQUESTED, data: {
    redirectUri, prompt, maxAge, loginHint, scope, idpHint, action, locale
}, resolve, reject  });
export const loginSucceeded = data => ({ type: LOGIN_SUCCEEDED, data });
export const loginFailed = data => ({ type: LOGIN_FAILED, data });
export const logoutRequested = (data, resolve, reject ) => ({ type: LOGOUT_REQUESTED, data, resolve, reject  });
export const logoutSucceeded = data => ({ type: LOGOUT_SUCCEEDED, data });
export const logoutFailed = data => ({ type: LOGOUT_FAILED, data });
